"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProviderJwt = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var provider_user_1 = require("@framework/provider-user");
var UserProviderJwt = function (props) {
    var _a = props.profile, defaultProfile = _a === void 0 ? null : _a, _b = props.storageName, storageName = _b === void 0 ? "user" : _b, children = props.children;
    var _c = (0, react_1.useState)(defaultProfile), profile = _c[0], setUserProfile = _c[1];
    return ((0, jsx_runtime_1.jsx)(provider_user_1.UserProvider, { profile: profile, setUserProfile: setUserProfile, storageName: storageName, children: children }));
};
exports.UserProviderJwt = UserProviderJwt;
//# sourceMappingURL=provider.js.map